import API_set_localize_list from "./set_localize_list";
import API_set_settings from "./set_settings";
import API_set_currency from "./set_currency";
import API_set_localize from "./set_localize";
import API_set_basket_currency from "./set_basket_currency";
import API_convert_price from "./convert_price";
import API_get_quota_services from "./get_quota_services";
import API_get_currency_rates from "./get_currency_rates";
import get from "./get";

export const Get = get;
export const SetLocalizeList = API_set_localize_list;
export const SetSettings = API_set_settings;
export const SetCurrency = API_set_currency;
export const SetLocalize = API_set_localize;
export const SetBasketCurrency = API_set_basket_currency;
export const convertPrice = API_convert_price;
export const getQuotaServices = API_get_quota_services;
export const getCurrencyRates = API_get_currency_rates;
